import type { WireAppTheme } from "@glideapps/theme";
import { useCoreTheme, isWireAppTheme } from "@glideapps/theme";

export function useWireAppTheme(): WireAppTheme {
    const theme = useCoreTheme();

    if (!isWireAppTheme(theme)) {
        // eslint-disable-next-line no-console
        console.error(`Tried to use a WireAppTheme but got a ${theme.themeKind}`);
    }

    return theme as WireAppTheme;
}
